module.exports = __webpack_public_path__ + "static/media/rune10.fbf2bc42.jpg";